// External dependencies
import PropTypes from 'prop-types';
import React from 'react';

// Internal dependencies
import AdminHeader from './AdminHeader.component.js';
import AdminSidebar from './AdminSidebar.component.js';

/**
 * Layout wrapper for admin pages that includes header and sidebar
 */
export default function AdminLayout({ children }) {
  return (
    <div className="admin-layout-wrapper">
      <AdminHeader />
      <div className="admin-layout">
        <AdminSidebar />
        <main className="admin-main">{children}</main>
      </div>
    </div>
  );
}

AdminLayout.propTypes = {
  children: PropTypes.node.isRequired,
};
